import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  const data = _taggedTemplateLiteral([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { Component, html } from 'lib/component';
import Canvas from 'canvas';
import fit from 'math-fit';
import anime from 'animejs';
import * as styles from './styles';
import size from 'size';
export default class CanvasTransition extends Component {
  render() {
    return html(_templateObject());
  }

  onRender() {
    this.classList.add(styles.canvas);
    if (this.useTransition) this.classList.add('u-hidden');
    this.rafId = -1;
    this.draw = this.draw.bind(this);
    this.canvas = new Canvas({
      parent: this
    });
    this.image = new Image();
    this.image.src = this.url;
    this.progress = {
      value: this.useTransition ? 0 : 1
    };
    this.scale = {
      value: this.useTransition ? 1.2 : 1
    };
    this.width = 0;
    this.height = 0;
    this.loaded = new Promise((resolve, reject) => {
      if (this.image.complete) {
        this.resizeImage();
        resolve();
      } else this.image.onload = () => {
        this.image.onload = null;
        this.resizeImage();
        resolve();
      };
    });
  }

  onResize() {
    let {
      width,
      height
    } = this.getBoundingClientRect();
    this.canvas.resize(width, height);
    this.width = width;
    this.height = height;
    this.resizeImage();
  }

  resizeImage() {
    this.cover = fit.cover({
      width: this.image.naturalWidth,
      height: this.image.naturalHeight
    }, {
      width: this.width,
      height: this.height
    });

    if (this.progress.value >= 1) {
      this.draw();
      this.stop();
    }
  }

  start() {
    this.stop();
    this.rafId = requestAnimationFrame(this.draw);
  }

  stop() {
    cancelAnimationFrame(this.rafId);
  }

  draw() {
    this.rafId = requestAnimationFrame(this.draw);
    let progress = this.progress.value;
    let dpr = this.canvas.ratio;
    let ctx = this.canvas.context;
    let {
      left,
      top,
      width,
      height
    } = this.cover;
    let w = width * dpr;
    let h = height * dpr;
    this.canvas.clear();
    let scale = this.scale.value;
    ctx.setTransform(scale * dpr, 0, 0, scale * dpr, 0, 0);
    ctx.save();
    ctx.beginPath();
    ctx.rect(0, this.height * (1 - progress) * 0.5, this.width, this.height * progress);
    ctx.clip(); // ctx.translate(-0.5 * (width * scale - width), -0.5 * (height * scale - height))
    // ctx.translate(-(width - size.width) * 0.5, -(height - size.height) * 0.5)

    ctx.drawImage(this.image, left + 0.5 * (width - scale * width), top + 0.5 * (height - scale * height), width, height);
    ctx.restore();
  }

  async animateIn(params, complete) {
    await this.loaded;
    anime({
      targets: this.progress,
      value: [0, 1],
      duration: 2000,
      easing: 'easeInOutQuart',
      begin: () => {
        this.start();
        this.classList.remove('u-hidden');
      },
      complete: () => this.stop()
    });
    anime({
      targets: this.scale,
      value: [1.2, 1],
      duration: 2000,
      easing: 'easeInOutQuart'
    });
  }

  onDestroy() {
    this.canvas.destroy();
  }

}
customElements.define('canvas-transition', CanvasTransition);